import * as React from "react";
import { Link } from "react-router-dom";

import { Grid } from "affinityUI/elements/grid";
import { Heading } from "affinityUI/structures/heading";
import { Layout } from "affinityUI/structures/layout";
import { Restricted } from "lib/auth";
import { PERMISSIONS } from "lib/biot/roles/types";
import { useAppSelector, warningSlice } from "lib/store";

import { ConfirmatoryTestInfoTag } from "../../../app/components/confirmatoryTestInfoTag";
import { PatientSearch } from "../../../app/components/patientSearch";
import { PatientsView } from "../../../views/patientDetails/patients";
import { useHospitalConfiguration } from "../../settings/context";

import { usePatients } from "./hooks/usePatients";

export const PatientsPage: React.FC = () => {
  const { hospitalConfig } = useHospitalConfiguration();
  const { patients, loading } = usePatients();
  const neutrophilWarning = useAppSelector((state) => state[warningSlice.name].neutrophilWarning);

  return (
    <Layout loading={loading} title="Patients" actions={<PatientSearch />}>
      <Grid>
        <Heading>
          <Heading.Meta>
            {neutrophilWarning && hospitalConfig ? (
              <ConfirmatoryTestInfoTag confirmatoryThreshold={hospitalConfig.confirmatoryThreshold} />
            ) : null}
          </Heading.Meta>
          <Heading.Actions>
            <Restricted permits={[PERMISSIONS.PATIENT_ADD]}>
              <Link to="add">Add patient</Link>
            </Restricted>
          </Heading.Actions>
        </Heading>
        {!loading && Boolean(patients) && <PatientsView patients={patients} />}
      </Grid>
    </Layout>
  );
};
